import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["textarea", "counter"]
  static values = {
    maxLength: { type: Number, default: 500 },
    minLength: { type: Number, default: 0 }
  }

  connect() {
    this.updateCounter()
  }

  updateCounter() {
    const currentLength = this.textareaTarget.value.length

    if (this.minLengthValue > 0) {
      this.#updateMinLengthCounter()
    } else {
      this.#updateMaxLengthCounter(currentLength)
    }
  }

  #updateMinLengthCounter() {
    const currentLength = this.textareaTarget.value.replace(/\r?\n/g, "").length
    if (currentLength === 0) {
      this.counterTarget.textContent = ""
      this.counterTarget.style.display = "none"
      return
    }

    const remaining = this.minLengthValue - currentLength
    if (remaining > 0) {
      this.counterTarget.textContent = `あと${remaining}文字`
      this.counterTarget.style.display = ""
      this.counterTarget.classList.add("a-text-red")
    } else {
      this.counterTarget.textContent = ""
      this.counterTarget.style.display = "none"
    }

    // maxLength による入力制限は維持
    if (currentLength > this.maxLengthValue) {
      this.textareaTarget.value = this.textareaTarget.value.substring(0, this.maxLengthValue)
    }
  }

  #updateMaxLengthCounter(currentLength) {
    const remainingChars = this.maxLengthValue - currentLength
    if (remainingChars >= 0) {
      this.counterTarget.textContent = `あと${remainingChars}文字まで`
      this.counterTarget.classList.remove("a-text-red")
    } else {
      this.counterTarget.textContent = "これ以上は入力できません"
      this.counterTarget.classList.add("a-text-red")
      this.textareaTarget.value = this.textareaTarget.value.substring(0, this.maxLengthValue)
    }
  }
}
